import { useState } from "react";
import { api } from "@/lib/api";
import { Loader2, Lock, Phone, User } from "lucide-react";

export default function Admin() {
  const [token, setToken] = useState("");
  const [leads, setLeads] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const load = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await api.get("/leads", { headers: { "X-Admin-Token": token } });
      setLeads(res.data);
    } catch (e) {
      setError("Nieprawidłowy token dostępu.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0F0E0E] text-[#F5F2F0] py-20 px-6">
      <div className="max-w-4xl mx-auto">
        <h1 className="font-display text-4xl md:text-5xl mb-2">Zgłoszenia</h1>
        <p className="text-muted mb-10">Panel leadów — Przemiana 1:1</p>

        {leads === null ? (
          <div className="border border-[#2A2626] bg-[#1A1718] p-8 max-w-md">
            <label className="text-xs uppercase tracking-[0.2em] text-muted flex items-center gap-2 mb-4">
              <Lock className="w-4 h-4" /> Token dostępu
            </label>
            <input
              data-testid="admin-token-input"
              value={token}
              onChange={(e) => setToken(e.target.value)}
              type="password"
              placeholder="••••••••"
              className="w-full bg-transparent border-b border-[#2A2626] py-3 outline-none focus:border-[#FF6B6B] transition-colors mb-2"
            />
            {error && <p className="text-[#FF6B6B] text-sm mt-2">{error}</p>}
            <button
              onClick={load}
              disabled={loading}
              data-testid="admin-login-button"
              className="btn-primary rounded-full px-6 py-3 text-sm font-semibold uppercase tracking-[0.15em] mt-6 flex items-center gap-2"
            >
              {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : null} Pokaż zgłoszenia
            </button>
          </div>
        ) : (
          <div>
            <p className="text-muted mb-6">Łącznie: {leads.length}</p>
            <div className="space-y-3">
              {leads.map((l) => (
                <div
                  key={l.id}
                  data-testid="admin-lead-row"
                  className="border border-[#2A2626] bg-[#1A1718] p-6 flex flex-col md:flex-row md:items-center justify-between gap-3"
                >
                  <div className="flex items-center gap-6">
                    <span className="flex items-center gap-2 text-[#F5F2F0]">
                      <User className="w-4 h-4 text-[#FF6B6B]" /> {l.name}
                    </span>
                    <a
                      href={`tel:${l.phone}`}
                      className="flex items-center gap-2 text-muted hover:text-[#FF6B6B]"
                    >
                      <Phone className="w-4 h-4" /> {l.phone}
                    </a>
                  </div>
                  <div className="flex items-center gap-4 text-sm text-muted">
                    {l.goal_kg ? (
                      <span className="text-[#FF6B6B]">cel -{l.goal_kg} kg</span>
                    ) : null}
                    <span>{new Date(l.created_at).toLocaleString("pl-PL")}</span>
                  </div>
                </div>
              ))}
              {leads.length === 0 && (
                <p className="text-muted">Brak zgłoszeń — jeszcze.</p>
              )}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
